import { Post } from 'generated/graphql';
import _ from 'lodash';

const randomId = (length = 8) => {
  return Math.random()
    .toString(36)
    .substring(2, length + 2);
};

const mapFileToMedia = (media?: File[]) => {
  if (!media || _.isEmpty(media)) return [];
  media.map((file: File) => {
    const imgUrl = URL.createObjectURL(file);
    const index = imgUrl.lastIndexOf('/');
    return {
      cdn0: imgUrl.substring(0, index + 1),
      image: imgUrl.substring(index + 1, imgUrl.length),
    };
  });
};

export const createDummyCommunityPost = ({
  username,
  profilePicture,
  text,
  media,
}: {
  username: string;
  profilePicture: string;
  text: string;
  media?: File[];
}): Post => {
  return {
    id: randomId(),
    createdAt: new Date(),
    author: {
      id: 123,
      badges: ['creator'],
      profilePicture,
      username,
    },
    text,
    updatedAt: new Date(),
    media: mapFileToMedia(media) || [],
    isSensitiveContent: false,
    reactions: [],
    replies: [],
  };
};
